<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-title-tip :theme="$otTheme" content="我靠左边" text-align="left" :width="100">
                <span>文字靠左</span>
            </ot-title-tip>
            <ot-title-tip :theme="$otTheme" content="我在中间" text-align="center" :width="100">
                <span>文字居中</span>
            </ot-title-tip>
            <ot-title-tip :theme="$otTheme" content="我靠右边" text-align="right" :width="100">
                <span>文字靠右</span>
            </ot-title-tip>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-title-tip%20content%3D%22%E6%88%91%E9%9D%A0%E5%B7%A6%E8%BE%B9%22%20text-align%3D%22left%22%20%3Awidth%3D%22100%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3E%E6%96%87%E5%AD%97%E9%9D%A0%E5%B7%A6%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-title-tip%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-title-tip%20content%3D%22%E6%88%91%E5%9C%A8%E4%B8%AD%E9%97%B4%22%20text-align%3D%22center%22%20%3Awidth%3D%22100%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3E%E6%96%87%E5%AD%97%E5%B1%85%E4%B8%AD%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-title-tip%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-title-tip%20content%3D%22%E6%88%91%E9%9D%A0%E5%8F%B3%E8%BE%B9%22%20text-align%3D%22right%22%20%3Awidth%3D%22100%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3E%E6%96%87%E5%AD%97%E9%9D%A0%E5%8F%B3%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-title-tip%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
